<div>
  <app-sia-wave-track
    [elementId]="'waveform'"
    [loadData]="data.asObservable()"
    [events]="eventsSubject.asObservable()"
    (duration)="getDuration($event)"
    (regionSelected)="saveRegions($event)"
    (pauseEvent)="onPauseButtonClick()"
    (currentTimeEvent)="getCurrentTime($event)"
  ></app-sia-wave-track>

  <section class="container container-controls" *ngIf="showButtons">
    <div class="grid left" *ngIf="showExtraTime">
      <header>
        <div class="grid-col"></div>
        <div class="grid-col">Start</div>
        <div class="grid-col"></div>
        <div class="grid-col">End</div>
      </header>
      <div class="grid-row">
        <div class="grid-col selection"></div>
        <div class="grid-col red">{{ hour }}:{{ start }}</div>
        <div class="grid-col text-red">
          {{ selectDuration }}
        </div>
        <div class="grid-col red">{{ hour }}:{{ end }}</div>
      </div>
    </div>

    <div class="center">
      <div class="controls">
        <button
          data-testid="zoom-in"
          mat-icon-button
          (click)="zoomIn()"
          class="icon-button"
        >
          <mat-icon>zoom_in</mat-icon>
        </button>
        <button
          data-testid="zoom-out"
          mat-icon-button
          (click)="zoomOut()"
          class="icon-button"
        >
          <mat-icon>zoom_out</mat-icon>
        </button>
        <button
          data-testid="replay"
          mat-icon-button
          (click)="replayTenSeconds()"
          class="icon-button"
        >
          <mat-icon>replay_10</mat-icon>
        </button>
        <button
          data-testid="previous"
          mat-icon-button
          (click)="onBackwardButtonClick()"
          class="icon-button"
          [disabled]="isBackwardButtonDisabled"
        >
          <mat-icon>skip_previous</mat-icon>
        </button>
        <button
          data-testid="play"
          (click)="onPlayButtonClick()"
          *ngIf="!play"
          class="icon-button"
        >
          <mat-icon class="bigger">play_circle</mat-icon>
        </button>
        <button
          data-testid="stop"
          (click)="onPauseButtonClick()"
          *ngIf="play"
          class="icon-button"
        >
          <mat-icon class="bigger">pause_circle</mat-icon>
        </button>
        <button
          data-testid="next"
          mat-icon-button
          (click)="onForwardButtonClick()"
          class="icon-button"
          [disabled]="isForwardButtonDisabled"
        >
          <mat-icon>skip_next</mat-icon>
        </button>
        <button
          data-testid="forward"
          mat-icon-button
          (click)="forwardTenSecond()"
          class="icon-button"
        >
          <mat-icon>forward_10</mat-icon>
        </button>
        <button
          data-testid="clear"
          mat-icon-button
          (click)="clear()"
          class="icon-button"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
      <div class="controls" *ngIf="showExtraTime">
        <p class="duration">
          {{ hour }}:{{ currentTime }} | {{ hour }}:{{ totalAudioDuration }}
        </p>
      </div>
    </div>
  </section>
</div>
